import React, { useEffect, useRef } from "react";
import styles from "./Terms.module.scss";
import logo from "../../img/Terms/logo.png";

const Terms = () => {
  // const focusRef = useRef();
  // useEffect(() => {
  //   focusRef.current.scrollIntoView({ behavior: "smooth" });
  // }, []);
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        ‘MondayOFF Party - Summer Splash’ Terms and Conditions
      </div>
      <div className={styles.TextBox}>
        <div className={styles.contents}>
          <div>
            By participating in this competition (MondayOFF Party), you agree to
            the collection and use of personal information related to these
            Terms and Conditions.
          </div>
          <br />
          <div>
            MondayOFF Party’s Terms and Conditions have legal effect between
            MondayOFF (“MondayOFF,” “we,” “us,” “our”) and a mobile application
            developer or development studio (“you,” “developer,” or “studio”).
            MondayOFF is the primary management body. MondayOFF shall collect
            and utilize data related to these Terms and Conditions.
          </div>
          <br />
          <div>
            Submitting a game means agreeing to participate in the MondayOFF
            Competition and for MondayOFF to collect and utilize the submitted
            information. By not agreeing with the above, participation will not
            be possible for the competition hosted by MondayOFF.
          </div>
          <br />
        </div>
        <div className={styles.title}>
          Competition Date (29.May.2023 to 7.July.2023)
        </div>
        <div className={styles.contents}>
          <div>
            During the competition period of 29.05.2023 to 07.07.2023 (May 29th,
            12 AM UTC+0 to July 7th, 11:59 PM UTC+0), you can submit your game
            to the MondayOFF Dashboard to participate in the MondayOFF
            Competition.
          </div>
          <br />
          <div>
            Submitting a game means that you agree to the Terms and Conditions
            stated above and thus agree to the MondayOFF Dashboard Terms and
            Conditions.
          </div>
          <br />
          <div>
            After game submission, MondayOFF shall conduct a test for each game
            and has the right to approve and reject the test for the submitted
            game.
          </div>
          <div>
            After the testing period, MondayOFF shall present the results to the
            studio or developer, including those who do not earn an award from
            the competition.
          </div>
          <br />
          <div>
            MondayOFF reserves the right to decide on the competition's
            cancellation, suspension, change, or extension at its own
            discretion.
          </div>
          <div>
            MondayOFF’s Dashboard allows unlimited game data improvement (ITR)
            tests during the competition period. But if the studio abuses
            additional testing without making any changes to the game, there may
            be restrictions on use.
          </div>
          <br />
        </div>
        <div className={styles.title}>Participation Qualifications</div>
        <div className={styles.contents}>
          <div>Adults 18 years of age or older.</div>

          <div>
            Those from countries where remittance is permitted with the Republic
            of Korea. The participating studio or developer must register the
            submitted game in the Android-Google Play Store.
          </div>
          <div>
            If the game has been released before the competition, it must have
            less than ten (10) thousand downloads from the submission date. (If
            the criteria are not satisfied, there may be restrictions on the
            prize money payment. Issues could also occur even if the stated
            criteria are met.)
          </div>
          <div>
            The game submission must occur between May 29th, 12AM UTC+0 - July
            7th, 11:59 PM UTC+0.
          </div>
          <br />
          <div>
            If the submitted game has previously been tested through the
            MondayOFF Dashboard or has a publishing contract with MondayOFF, the
            studio or developer cannot submit that game to participate in the
            MondayOFF Competition. Even if the game in question satisfies the
            competition's prize payment KPI, it will be excluded from the prize
            payment since it was already previously tested with MondayOFF.
          </div>
          <br />
        </div>
        <div className={styles.title}>Prize Payment Criteria and KPIs</div>
        <div className={styles.contents}>
          <div>Main Prize</div>
          <div>Prize: $1M Minimum Guarantee (MG)</div>
          <div>
            A $1.000.000 (one million) Minimum Guarantee shall be awarded as a
            prize if the game is a accepted for a “Publishing and Licensing
            Contract” and obtains a global commercial launch from MondayOFF, and
            such game reaches more than 6M (Six million) downloads on US iOS
            within six (6) months from the game's release.
          </div>
          <br />
        </div>
        <div className={styles.title}>Award payment criteria and methods</div>
        <div className={styles.contents}>
          For a nominated game to receive the Minimum Guarantee prize, that said
          game must first obtain a “Publishing and Licensing Agreement” contract
          from MondayOFF. The timing and form of the subsequent payment of the
          prize money shall follow the publishing contract, and the prize
          payment shall be included in the revenue share). After signing a
          publishing contract, an additional Evaluation Period shall occur to
          analyze other game data. The above-stated process is for accurate data
          analysis of the game. Depending on the game, the Evaluation Period may
          vary in time.
        </div>
        <br />
        <div className={styles.title}>Evaluation Period</div>
        <div className={styles.contents}>
          Among the games submitted during the competition, games that meet the
          criteria for the Minimum Guarantee prize may take at least one (1)
          week to a maximum of six (6) months for additional necessary testing
          to obtain accurate game data analysis.
        </div>
        <br />
        <div className={styles.title}>Bonus Prize</div>
        <div className={styles.contents}>
          <div>MondayOFF’s Choice: $2,000 (two thousand)</div>
          <div>
            MondayOFF’s Choice will be awarded to the game that is voted as
            favorite by the MondayOFF team. Among the submitted games during the
            competition period, the prize will be given in the form of a lump
            sum to the selected game.
          </div>
          <br />
          <div>Most Unique: $2,000 (two thousand)</div>
          <div>
            Most Unique will be awarded to the game that is voted as the most
            original concept by the MondayOFF team. MondayOFF will give the
            prize money in the form of a lump sum to the selected game.
          </div>
          <br />
          <div>Best Hybrid: $2,000 (two thousand)</div>

          <div>
            Best Hybrid will be awarded to the game that is voted best in the
            hybridcasual category by the MondayOFF team. MondayOFF will give the
            prize money in the form of a lump sum to the selected game.
          </div>
          <br />
          <div>
            Winners are selected from a large pool of participants. There could
            also not be any winners at all. Winners will be selected at
            MondayOFF’s own discretion.
          </div>
          <br />
        </div>

        <div className={styles.title} id="trigger">
          Flexible KPIs
        </div>
        <div className={styles.contents}>
          MondayOFF Party - Summer Splash is an event that provides Publishing
          Contracts with a Minimum Guarantee based on flexible KPIs.
        </div>

        <div className={styles.contents}>
          <div>
            During the event duration of 29/05/2023 to 07/07/2023 (May 29th, 12
            AM to July 7th, 11:59 PM (UTC+0), you can submit your game to the
            MondayOFF dashboard to participate in the event ‘MondayOFF Party -
            Summer Splash.’ Game refers to only hyper-casual, hybrid-casual,
            casual, and idle arcade mobile games.
          </div>
          <div>
            Submitting a game means that you agree to the Terms and Conditions
            stated above and thus agree to the MondayOFF Dashboard Terms and
            Conditions.
          </div>
          <br />
          <div>
            After game submission, MondayOFF shall conduct a test for each game
            and has the right to approve and reject the test for the submitted
            game.
          </div>
          <div>
            After the test, MondayOFF shall present the results to the studio or
            developer, including those who do not earn an award from the
            competition.
          </div>
        </div>
        <br />
        <div className={styles.title}>Winning Conditions</div>

        <div className={styles.contents}>
          <div>
            All competition game submissions are subject to evaluation by the
            following points table.
          </div>
          <br />
          <table className={styles.table}>
            <tbody className={styles.winning_table}>
              <tr className={styles.winning_table_first}>
                <td className={styles.table_contents}>Factor/Points</td>
                <td className={styles.table_contents}>1</td>
                <td className={styles.table_contents}>2</td>
                <td className={styles.table_contents}>3</td>
              </tr>
              <tr className={styles.winning_table_second}>
                <td className={styles.table_contents}>CPI($)</td>
                <td className={styles.table_contents}>0.7</td>
                <td className={styles.table_contents}>0.5</td>
                <td className={styles.table_contents}>0.3</td>
              </tr>
              <tr className={styles.winning_table_third}>
                <td className={styles.table_contents}>D1 Ret</td>
                <td className={styles.table_contents}>30%</td>
                <td className={styles.table_contents}>40%</td>
                <td className={styles.table_contents}>45%</td>
              </tr>
              <tr className={styles.winning_table_fourth}>
                <td className={styles.table_contents}>D0 Average Playtime</td>
                <td className={styles.table_contents}>900s</td>
                <td className={styles.table_contents}>1200s</td>
                <td className={styles.table_contents}>1500s</td>
              </tr>
            </tbody>
          </table>
          <br />
          {/* <div className={styles.subTitle}>Idle Arcade KPI</div>
          <div className={styles.table}>
            <div className={styles.menu}>
              <div>CPI</div>
              <div>D1 Ret</div>
              <div>PlayTime</div>
              <div>Points</div>
            </div>
            <div className={styles.first}>
              <div>$0.8</div>
              <div>25%</div>
              <div>1000s</div>
              <div>1</div>
            </div>
            <div className={styles.second}>
              <div>$0.7 </div>
              <div>30%</div>
              <div>1300s</div>
              <div>2</div>
            </div>
            <div className={styles.third}>
              <div>$0.6</div>
              <div>40%</div>
              <div>1500s</div>
              <div>3</div>
            </div>
            <div className={styles.fourth}>
              <div>$0.5</div>
              <div>45%</div>
              <div>1700s</div>
              <div>4</div>
            </div>
            <div className={styles.fifth}>
              <div>$0.4</div>
              <div>50%+ </div>
              <div>2000s</div>
              <div>5</div>
            </div>
          </div> */}
          <br />
        </div>
        <div className={styles.title}>Eligibility</div>
        <div className={styles.contents}>
          Games that have been tested on the MondayOFF Dashboard are eligible to
          receive a “Publishing and Licensing Agreement” contract offer by
          MondayOFF with a Minimum Guarantee based on the results of the three
          categories’ scores (CPI, D1 Retention, and Playtime) summed up. The
          game and marketing data is collected and provided by MAX by AppLovin.
          All three categories’ minimum KPIs must be met to be eligible and only
          MAX data will be counted toward the score. MondayOFF reserves the
          right to offer Publishing Contracts at its discretion.
        </div>
        <br />
        <div className={styles.title}>Prize Table</div>
        <table className={styles.table}>
          <thead className={styles.menu}>
            <tr>
              <th className={styles.table_title}>Points</th>
              <th className={styles.table_title}>MG</th>
            </tr>
          </thead>
          <tbody className={styles.prize_table}>
            <tr className={styles.first}>
              <td className={styles.table_contents}>9</td>
              <td className={styles.table_contents}>$50,000</td>
            </tr>
            <tr className={styles.second}>
              <td className={styles.table_contents}>7-8 </td>
              <td className={styles.table_contents}>$20,000 </td>
            </tr>
            <tr className={styles.third}>
              <td className={styles.table_contents}>5-6 </td>
              <td className={styles.table_contents}>$10,000</td>
            </tr>
            <tr className={styles.fourth}>
              <td className={styles.table_contents}>3-4</td>
              <td className={styles.table_contents}>$5,000</td>
            </tr>
          </tbody>
        </table>

        <br />
        <div className={styles.title}>Prize payment criteria and methods</div>
        <div className={styles.contents}>
          For a nominated game to receive the Minimum Guarantee prize, that said
          game must first obtain a “Publishing and Licensing Agreement”
          (publishing contract) from MondayOFF. The timing and form of the
          subsequent payment of the prize money shall follow the publishing
          contract, and the prize payment shall be included in the revenue
          share.
        </div>
        <br />
        {/* <div className={styles.title}>Evaluation Period</div>
        <div className={styles.contents}>
          Among the games submitted during the competition, games that meet the
          Summer Flex Minimum Guarantee prize criteria may take at least one (1)
          week to a maximum of two (2) months for additional necessary testing
          to obtain accurate game data analysis.
        </div> */}
        <br />
        <div className={styles.title}>Intellectual Property and Data</div>
        <div className={styles.contents}>
          <div>
            Under the Terms and Conditions of the MondayOFF Party, you agree to
            give MondayOFF the right to use your game's name, logo, or other
            trademarks for marketing purposes.
          </div>
          <div>
            You also agree that your registration information (e-mail, name,
            company, country, etc.) will be stored by submitting the game and
            accepting the terms and conditions. Such information is used to meet
            MondayOFF's marketing, operations, and legal regulations.
          </div>
          <br />
          <div>
            We store your registration information to meet the above purposes.
            MondayOFF does not sell, share, or distribute your information to
            any other company except our partners to fulfill that purpose, which
            may apply a privacy policy that is not the same as your
            jurisdiction.
          </div>
          <br />
          <div>
            Within the data protection policy, you can contact
            publishing@mondayoff.me for restrictions on data handling, deletion
            of personal information, or transmission of your data.
          </div>
          <br />
        </div>

        <div className={styles.title}>No warranty</div>
        <div className={styles.contents}>
          <div>
            MondayOFF makes no warranties and, as a result of this, disclaims
            all warranties, expressed or implied, concerning ‘MondayOFF Party -
            Summer Splash’. Without limiting the generality of the preceding,
            the prizes (if any) are provided “as is” without warranty of any
            kind, either expressed or implied. MondayOFF, as a result of this,
            disclaims all such warranties, including but not limited to the
            implied warranties of merchantability.
          </div>
          <br />
          <div>
            You agree to release and hold harmless MondayOFF from and against
            all rights, claims, and causes of action whatsoever that you may
            have, or which may arise, against you for any liability for any
            reason whatsoever, including but not limited to any loss or damage,
            whether direct, compensatory, incidental or consequential, arising
            in whole or in part, directly or indirectly, from your participation
            in the ‘MondayOFF Party - Summer Splash.’
          </div>
          <br />
        </div>

        <div className={styles.title}>Assignment</div>

        <div className={styles.contents}>
          You may not assign these terms, your participation in the ‘MondayOFF
          Party - Summer Splash’ or any prizes to any third party. Any such
          assignment shall be null and void.
        </div>
        <br />
        <div className={styles.title}>Jurisdiction and applicable law</div>
        <div className={styles.contents}>
          These terms are governed by, construed, and enforced per the laws of
          the Republic of Korea, without regard to its conflicts of law
          principles or provisions. Any dispute arising out of or in connection
          with these Terms and Conditions and/or the ‘MondayOFF Party - Summer
          Splash’ shall be subject to the exclusive jurisdiction of the Republic
          of Korea's courts.
        </div>
      </div>
      <div className={styles.companyInfo}>
        <div>Contact : publishing@mondayoff.me</div>
        <div>
          Location : 14F, 465, Bongeunsa-ro, Gangnam-gu, Seoul, Republic of
          Korea
        </div>
        <div>COPYRIGHT MondayOff Inc. ©2022. ALL RIGHTS RESERVED.</div>
        <img src={logo} alt="MondayOFF" className={styles.logo} />
      </div>
    </div>
  );
};

export default Terms;
